export enum Path {
  Projects = 'projects',
  Subprojects = 'subprojects',
  Orders = 'orders',
  Companies = 'companies',
  Planners = 'planners',
  Contractors = 'contractors',
  Contacts = 'contacts',
  Users = 'users',
  Stats = 'stats',
  InspectionsBank = 'inspections-bank',
  RestoreAccess = 'restore',
  ChangePass = 'changePass',
  Login = 'login',
  Logout = 'logout',
  Refresh = 'refresh',
  App = 'app',
  Auth = 'auth',
  Reminders = 'reminders',
  Configuration = 'configuration',
  History = 'history',
  FireAlarmComponents = 'fire-alarm-components',
  InspectionFields = 'inspection-fields',
  CompanyStatus = 'companystatus',
  OrderStatus = 'orderstatus',
  InspectionStandards = 'inspection-standards',
  InspectionTypes = 'inspection-types',
  Cities = 'cities',
  InspectionTemplates = 'inspection-templates',
  Permissions = 'permissions',
  Inspector = 'inspector',
  SchedulingDurations = 'scheduling-durations',
  SchedulingDurationBuckets = 'scheduling-settings/duration-buckets',
  AiSettings = 'ai-settings',
  /** Settings hub: AI sections and system information. */
  SuperAdmin = 'super-admin',
  WatchedMailboxes = 'ai-settings/watched-mailboxes',
  RoutingRules = 'ai-settings/routing-rules',
  RoutingTargets = 'ai-settings/routing-targets',
  OutlookCategories = 'ai-settings/outlook-categories',
  MailTriage = 'mail-triage',
  MailTriageEvents = 'mail-triage/events',
  /** OAuth consent page for chat connectors (Claude / ChatGPT). */
  McpConnect = 'connect',
  /** The signed-in user's own chat connections (under McpConnect). */
  McpConnections = 'connections'
}
